export default {
  search: 'Ara',
  Active: 'Aktif',
  Passive: 'Pasif',
  DateRange: 'Tarih Aralığı',
  Group: 'Grup',
  TariffCode: 'Tarife kodu',
  InstalledPower: 'Kurulu güç',
  Accord: 'Anlaşma',
  Adress: 'Adres',
  date: 'Tarih',
  UserDefinedAlarms: 'Kullanıcı Tanımlı Alarm',
  dimensions: {

  },
  measures: {

  },
  table: {
    name: 'İsim',
  },

};
